
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function AboutSection() {
  const { t } = useTranslation('common');

  const scrollToCompany = () => {
    const element = document.getElementById('company');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="company" className="py-24 px-6 bg-gradient-to-b from-amber-900 to-amber-950 text-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-block px-4 py-2 bg-rose-100/20 rounded-lg mb-6">
            <span className="text-sm text-rose-100">{t('about.label')}</span>
          </div>

          <h2 className="text-6xl font-bold mb-8 max-w-4xl">
            {t('about.title')}
          </h2>

          <div className="max-w-3xl space-y-4 mb-16">
            <p className="text-lg text-white/90">{t('about.desc1')}</p>
            <p className="text-lg text-white/90">{t('about.desc2')}</p>
            <p className="text-base text-white/70">{t('about.desc3')}</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center"
        >
          <div className="w-full h-96 rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/24aeac95850e55fcda9f6af40f64c6a6/929a66c627eb1766370749babaeec463.png"
              alt="Our Team"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <p className="text-8xl font-bold mb-4">{t('about.years')}</p>
            <p className="text-xl text-white/90 mb-2">{t('about.yearsDesc1')}</p>
            <p className="text-base text-white/70 mb-8">{t('about.yearsDesc2')}</p>
            <button
              onClick={scrollToCompany}
              className="px-8 py-4 bg-white text-gray-900 rounded-full text-base font-medium hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('about.button')}
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
